import { backofficeOnlyConfig } from '../../config/global'
import { Country } from '../../global/types'
import { getUseAPI } from '../../utils/api'

const { useAPI } = getUseAPI(backofficeOnlyConfig.iamLoginBaseUrl)

export const useGetCountries = () => useAPI<Country[]>('/countries')
